import React from 'react'
import './css/app1.css'

export default function GetInTouch() {
  return (
   <>
   <div className="getintouch">
    <div className="getintouchContainer">
    <div className="getInTouchHeading">
        <h1>GET IN TOUCH!</h1>
    </div>
    <div className="getInTouchPara">
        <p>Get in touch with us to discuss how we can elevate your digital marketing strategy and drive results for your business. Our team is ready to answer your questions, provide tailored solutions, and guide you through every step of the process. Reach out today to start your journey toward digital success. </p>
    </div>
    <div className="col-md-12 getcontact">
        <form action="https://formsubmit.co/zoher@rajdigi.com" method="POST">
            <div className="row contactContainer">
        <div className="col-md-3">
            <div className="getintouchInput">
                <input type="text" name="Name" placeholder='Name' />
            </div>
        </div>
        <div className="col-md-3">
            <div className="getintouchInput">
                <input type="text" name="Email" placeholder='Email Id' />
            </div>
        </div>
        <div className="col-md-3">
            <div className="getintouchInput">
                <input type="text" name="Services" placeholder='Services' />
            </div>
        </div>
        <div className="col-md-3">
            <div className="getintouchInput">
                <input type="text" name="Contact" placeholder='Contact' />
            </div>
        </div>
        </div>
        
            <div className="row section-anothercol">
            
        <div className="col-md-9">
          <div className="getintouchInput">
            <input type="text" name="Message" placeholder='Message' />
            </div>  
            
        </div>
        <div className="col-md-3">
                <div className="getinTouchBtn">
                    <input type="submit" />
                </div>
            </div>
        
        </div>
        </form>
    </div>
    </div>
   </div>
   </>
  )
}
